import React, { useState, useEffect } from "react";
// @material-ui/core components
import { Grid, Tabs, Tab } from "@material-ui/core";
// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import tableStyles from "../../../../assets/jss/components/tableStyle";
import styles from "../../../../assets/jss/layouts/appStyle";
// core components
import { LOCALE } from "../../../../properties/Locale";
import ProfessionalEventTypeComponent from "./professionalEventType/ProfessionalEventTypeComponent";
import ProfessionalEventRoleComponent from "./professionalEventRole/ProfessionalEventRoleComponent";
import ProfessionalEventSchemaPointComponent from "./professionalEventSchemaPoint/ProfessionalEventSchemaPointComponent";

const useStyles = makeStyles(styles, tableStyles);

export default function ProfessionalEventConfigComponent(props) {
  const classes = useStyles();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };
  return (
    <div>
      <Grid container style={{ paddingTop: "25px" }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label={LOCALE.event} />
          <Tab label={LOCALE.training_role} />
          <Tab label={LOCALE.schema_points} />
        </Tabs>
        {tabIndex === 0 && (
          <ProfessionalEventTypeComponent
            gradingSchemaId={props.gradingSchemaId}
          />
        )}
        {tabIndex === 1 && (
          <ProfessionalEventRoleComponent
            gradingSchemaId={props.gradingSchemaId}
          />
        )}
        {tabIndex === 2 && (
          <ProfessionalEventSchemaPointComponent
            gradingSchemaId={props.gradingSchemaId}
          />
        )}
      </Grid>
    </div>
  );
}
